/**
 * Mapeia passageiro do wizard para payload da API BPe (pré-reserva / emissão).
 */
export function mapPassengerToApi(passenger, extra = {}) {
  const p = passenger || {};
  return {
    categoria_passageiro: p.categoria || "geral",
    declaracao_documentacao_beneficio:
      p.declaracaoDoc === true || p.declaracao_documentacao_beneficio === true,
    data_nascimento_gratuidade:
      p.dataNascimento || p.data_nascimento_gratuidade || p.data_nascimento || undefined,
    renda_mensal_gratuidade:
      p.rendaMensal != null && String(p.rendaMensal).trim() !== ""
        ? p.rendaMensal
        : p.renda_mensal_gratuidade ?? p.renda_mensal ?? undefined,
    nome: p.nome,
    documento: p.documento,
    email: p.email,
    celular: p.celular,
    cidade: p.cidade,
    cep: p.cep,
    endereco: p.endereco,
    ...extra,
  };
}
